import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-contact-form" }
const _hoisted_2 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_User = _resolveComponent("User")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_MessageBox = _resolveComponent("MessageBox")!
  const _component_Phone = _resolveComponent("Phone")!
  const _component_Message = _resolveComponent("Message")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "app-contact-form-title" }, [
        _createElementVNode("h2", { "txt-center": "" }, [
          _createTextVNode("Contact Us "),
          _createElementVNode("br")
        ]),
        _createElementVNode("p", { "txt-center": "" }, " Have a Query? We love assisting you. Get in touch with us and we will get back to you shortly. ")
      ], -1)),
      _createElementVNode("div", null, [
        (_ctx.keyIsValid !== false)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              rules: _ctx.rules,
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
              class: "App-Styled-Form",
              "label-position": 'top',
              "label-width": "100px",
              model: _ctx.form,
              style: {"margin-top":"12px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "names",
                  label: "names"
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_User)
                      ]),
                      _: 1
                    }),
                    _cache[5] || (_cache[5] = _createTextVNode(" Names ", -1))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "John Doe",
                      modelValue: _ctx.form.names,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.names) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  prop: "email",
                  label: "Email"
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_MessageBox)
                      ]),
                      _: 1
                    }),
                    _cache[6] || (_cache[6] = _createTextVNode(" Email Address ", -1))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "johndoe@e4t.com",
                      modelValue: _ctx.form.email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  prop: "phone",
                  label: "Phone"
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Phone)
                      ]),
                      _: 1
                    }),
                    _cache[7] || (_cache[7] = _createTextVNode(" Contact Telephone (With code) ", -1))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "+250780010733",
                      modelValue: _ctx.form.phone,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.phone) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.form.key === undefined)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: "message",
                      label: "Message"
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Message)
                          ]),
                          _: 1
                        }),
                        _cache[8] || (_cache[8] = _createTextVNode(" message ", -1))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          placeholder: "Message/question/comment",
                          modelValue: _ctx.form.message,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.message) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_button, {
                    disabled: !_ctx.form.message || !_ctx.form.names || !_ctx.form.email,
                    "is-block": "",
                    size: "large",
                    type: "primary",
                    icon: "el-icon-position",
                    onClick: _ctx.submit
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" Submit ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]),
              _: 1
            }, 8, ["rules", "model"])), [
              [_directive_loading, _ctx.loading]
            ])
          : _createCommentVNode("", true)
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}